<template>
    <div class="container-fluid pt-section-fix pb-4" id="gdpr">
        <div class="row position-relative">
            <div class="col-12 col-md-3 col-xl-2 section-main-title">
                <div class="d-block d-md-inline-block main-background">GDPR</div>
            </div>
            <div class="col-12 col-md-9 col-xl-10" role="tablist">
                <div>
                    <div role="tab">
                        <button class="btn btn-outline-info d-flex w-100 mb-2 text-left align-items-center"
                                :class="{'active': activeTab === 'personalData'}"
                                @click="collapseControls( 'personalData')">
                            <div class="flex-grow-1">
                                Политика за защита на личните данни
                            </div>
                            <div class="flex-grow-0">
                                <font-awesome-icon icon="chevron-down"
                                                   :transform="{ rotate: activeTab === 'personalData'?180:0 }"></font-awesome-icon>
                            </div>
                        </button>
                    </div>
                    <b-collapse id="personalData" visible accordion="gdpr-accordion" role="tabpanel">
                        <gdpr-personal-data-text></gdpr-personal-data-text>
                    </b-collapse>
                </div>
                <div>
                    <div role="tab">
                        <button class="btn btn-outline-info d-flex w-100 mb-2 text-left align-items-center"
                                :class="{'active': activeTab === 'cookiesPolicies'}"
                                @click="collapseControls( 'cookiesPolicies')">
                            <div class="flex-grow-1">
                                Политика за използване на „бисквитки“
                            </div>
                            <div class="flex-grow-0">
                                <font-awesome-icon icon="chevron-down"
                                                   :transform="{ rotate: activeTab === 'cookiesPolicies'?180:0 }"></font-awesome-icon>
                            </div>
                        </button>
                    </div>
                    <b-collapse id="cookiesPolicies" accordion="gdpr-accordion" role="tabpanel">
                        <gdpr-cookies-text></gdpr-cookies-text>
                    </b-collapse>
                </div>
                <div>
                    <div role="tab">
                        <button class="btn btn-outline-info d-flex w-100 mb-2 text-left align-items-center"
                                :class="{'active': activeTab === 'termsAndConditions'}"
                                @click="collapseControls( 'termsAndConditions')">
                            <div class="flex-grow-1">
                                Общи условия за използване на платформата АдминПлюс
                            </div>
                            <div class="flex-grow-0">
                                <font-awesome-icon icon="chevron-down"
                                                   :transform="{ rotate: activeTab === 'termsAndConditions'?180:0 }"></font-awesome-icon>
                            </div>
                        </button>
                    </div>
                    <b-collapse id="termsAndConditions" accordion="gdpr-accordion" role="tabpanel">
                        <gdpr-terms-text></gdpr-terms-text>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GdprPersonalDataText from "./gdpr-personal-data-text";
    import GdprCookiesText from "./gdpr-cookies-text";
    import GdprTermsText from "./gdpr-terms-text";

    export default {
        name: "gdpr-component",
        components: {GdprTermsText, GdprCookiesText, GdprPersonalDataText},
        data() {
            return {
                activeTab: 'personalData'
            }
        },
        methods: {
            collapseControls(id) {
                if (this.activeTab !== id) {
                    this.$root.$emit('bv::toggle::collapse', id);
                    this.activeTab = id;
                }
            }
        }
    }
</script>

<style scoped>
</style>
